import "./OurBlogs.scss";

// code imports
import React, { useEffect, useState } from "react";
import Reveal from "../../common/UI_Elements/Reveal";

// The blog lives in the separate "worldcup" app: we read its API (latest 4 posts) and link back to it,
// but the cards use this site's own look
const BLOG_SITE = "https://hitwicket.com/worldcup/blogs";
const BLOG_API = "https://hitwicket.com/worldcup/api/blogs/?filter[isAlive]=true&limit=4&skip=0";
const FALLBACK_IMAGE = "https://cdn.octathorpeweb.com/v1/website/sachinxhw/trailer_thumbnail_v1.webp";

// "22 Jan 2026" (IST), as on the blog page
function formatDate(value) {
    return new Date(value).toLocaleString("en-US", { timeZone: "Asia/Kolkata", month: "short", day: "2-digit", year: "numeric" });
}

// same reading-time rule as the blog page: words inside <p> tags / 275 wpm
function readTime(html) {
    if (!html) return "1 min read";
    const re = /<p[^>]*>([^<]*)<\/p>/gi;
    let words = 0;
    let m;
    while ((m = re.exec(html)) !== null) words += m[1].trim().split(/\s+/).length;
    const mins = Math.ceil(words / 275);
    return mins < 2 ? "1 min read" : `${mins} min read`;
}

const Icon = ({ children }) => (
    <svg className="OurBlogs-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        {children}
    </svg>
);

function BlogCard({ post }) {
    return (
        <a className="BlogCard" href={`${BLOG_SITE}/${post.permalink}`}>
            <div className="blog-thumb">
                <img src={post.featureImage || FALLBACK_IMAGE} alt="" loading="lazy" />
            </div>
            <div className="BlogCard-info">
                <h3 className="title">{post.title}</h3>
                <ul>
                    {post.publishedDate && (
                        <li>
                            <Icon><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></Icon>
                            {formatDate(post.publishedDate)}
                        </li>
                    )}
                    {post.content && (
                        <li>
                            <Icon><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></Icon>
                            {readTime(post.content)}
                        </li>
                    )}
                    {post.likes > 0 && (
                        <li>
                            <Icon><path d="M12 20s-7-4.4-9-9.2C1.9 7.6 4 4.5 7.2 4.5c1.9 0 3.3 1 4.8 2.8 1.5-1.8 2.9-2.8 4.8-2.8 3.2 0 5.3 3.1 4.2 6.3C19 15.6 12 20 12 20z" /></Icon>
                            {post.likes}
                        </li>
                    )}
                    {post.comments > 0 && (
                        <li>
                            <Icon><path d="M21 12a8 8 0 01-11.6 7.1L4 20l1-4.6A8 8 0 1121 12z" /></Icon>
                            {post.comments}
                        </li>
                    )}
                </ul>
            </div>
        </a>
    );
}

function OurBlogs() {
    const [posts, setPosts] = useState(null); // null = loading, [] = nothing to show

    useEffect(() => {
        const controller = new AbortController();
        fetch(BLOG_API, { signal: controller.signal })
            .then((res) => res.json())
            .then((json) => setPosts(json.success && Array.isArray(json.data) ? json.data.slice(0, 4) : []))
            .catch((err) => {
                if (err.name !== "AbortError") setPosts([]); // fail quietly: the section just doesn't show
            });
        return () => controller.abort();
    }, []);

    if (posts && posts.length === 0) return null;

    return (
        <Reveal className="OurBlogs col-12">
            <div className="OurBlogs-inner">
                <h2 className="OurBlogs-heading SectionHeading text-center text-white fw-bold">Major Game Updates</h2>

                {posts === null && (
                    <div className="OurBlogs-loading">
                        <div className="spinner-border text-light" role="status" aria-label="Loading blogs" />
                    </div>
                )}

                {posts !== null && (
                    <div className="OurBlogs-grid">
                        {posts.map((post) => (
                            <BlogCard key={post._id} post={post} />
                        ))}
                    </div>
                )}

                <div className="OurBlogs-moreWrap">
                    <a className="OurBlogs-more" href={BLOG_SITE}>View More</a>
                </div>
            </div>
        </Reveal>
    );
}

export default OurBlogs;
